module.exports = __webpack_public_path__ + "static/media/logo-login.e58d5987.png";


//////////////////
// WEBPACK FOOTER
// ./src/kmcAssets/img/logo-login.png
// module id = 1586
// module chunks = 1137